import { deleteData, getData, postData } from "@/request/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

/* ── عِش فيه يوم كامل ── */
export const useDayInLife = () => {
  return useMutation({
    mutationFn: async (data: { slug: string; locale: string }) => {
      const res = await postData("ai/day-in-life", data);
      return res.data as {
        day: { morning: string; noon: string; evening: string; night: string };
      };
    },
  });
};

/* ── خريطة حياتي: الأماكن ── */
export const useLifePlaces = (enabled = true) => {
  return useQuery({
    queryKey: ["life-places"],
    enabled,
    queryFn: async () => (await getData("life/places")).data?.places ?? [],
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};

export const useAddPlace = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => (await postData("life/places", data)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["life-places"] }),
  });
};

export const useDeletePlace = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => (await deleteData(`life/places/${id}`)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["life-places"] }),
  });
};

/* commute from a property to ALL my places */
export const useCommuteToMyPlaces = () => {
  return useMutation({
    mutationFn: async (data: { fromLat: number; fromLng: number }) => {
      const res = await postData("life/commute", data);
      return res.data?.results ?? [];
    },
  });
};

/* ── مراقب السوق الشخصي ── */
export const useMarketMonitor = (enabled = true) => {
  return useQuery({
    queryKey: ["market-monitor"],
    enabled,
    queryFn: async () => (await getData("ai/market-monitor")).data,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
};
